import { render, staticRenderFns } from "./HeaderDetails.vue?vue&type=template&id=cbdb0bf4"
import script from "./HeaderDetails.vue?vue&type=script&lang=js"
export * from "./HeaderDetails.vue?vue&type=script&lang=js"
import style0 from "./HeaderDetails.vue?vue&type=style&index=0&id=cbdb0bf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
